import { render, staticRenderFns } from "./CouponsScan.vue?vue&type=template&id=767c317e&scoped=true"
import script from "./CouponsScan.vue?vue&type=script&lang=js"
export * from "./CouponsScan.vue?vue&type=script&lang=js"
import style0 from "./CouponsScan.vue?vue&type=style&index=0&id=767c317e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c317e",
  null
  
)

export default component.exports